import { createContext } from "react";
const TestimonialMultipageContext = createContext({});
export default TestimonialMultipageContext;
